'use client'

import React from 'react'

// Componente Hexagonal DECORATIVO - sin texto, sin precio, sin link
// Solo forma geométrica con gradiente sutil para collage visual
const HexagonOption = ({ variant = 0 }: { variant?: number }) => {
  // 12 variantes de gradientes (mezcla de cálidos y fríos)
  const gradients = [
    'from-orange-500/20 via-rose-500/15 to-pink-500/20',
    'from-blue-500/20 via-cyan-500/15 to-sky-500/20',
    'from-violet-500/20 via-purple-500/15 to-fuchsia-500/20',
    'from-amber-500/20 via-orange-500/15 to-red-500/20',
    'from-indigo-500/20 via-blue-500/15 to-cyan-500/20',
    'from-pink-500/20 via-rose-500/15 to-orange-500/20',
    'from-teal-500/20 via-emerald-500/15 to-cyan-500/20',
    'from-fuchsia-500/20 via-pink-500/15 to-rose-500/20',
    'from-sky-500/20 via-blue-500/15 to-indigo-500/20',
    'from-yellow-500/15 via-amber-500/15 to-orange-500/20',
    'from-rose-500/20 via-pink-500/15 to-fuchsia-500/20',
    'from-cyan-500/20 via-sky-500/15 to-blue-500/20',
  ]
  const strokeColors = [
    'stroke-orange-400/60',
    'stroke-blue-400/60',
    'stroke-violet-400/60',
    'stroke-amber-400/60',
    'stroke-cyan-400/60',
    'stroke-rose-400/60',
    'stroke-emerald-400/60',
    'stroke-fuchsia-400/60',
    'stroke-sky-400/60',
    'stroke-yellow-400/60',
    'stroke-pink-400/60',
    'stroke-blue-300/60',
  ]

  return (
    <div className="relative w-[180px] h-[207px] md:w-[180px] md:h-[207px] sm:w-[150px] sm:h-[173px] max-sm:w-[126px] max-sm:h-[145px]">
      {/* SVG Hexágono decorativo */}
      <svg
        className="absolute inset-0 w-full h-full transition-transform duration-700 hover:scale-110"
        viewBox="0 0 100 115"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id={`grad-${variant}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="white" stopOpacity="0.15" />
            <stop offset="50%" stopColor="white" stopOpacity="0.05" />
            <stop offset="100%" stopColor="white" stopOpacity="0.12" />
          </linearGradient>
        </defs>
        <polygon
          points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
          fill={`url(#grad-${variant})`}
          className={`${strokeColors[variant]} stroke-2 transition-all duration-700 hover:stroke-[3px]`}
        />
      </svg>
    </div>
  )
}

const Hero = () => {
  // Ya no necesitamos useState ni useEffect para el indicador de dedo
  // ni useRouter para navegación (los hexágonos son solo decorativos)

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Estilos para el diseño hexagonal */}
      <style jsx>{`
        .hexagon-container {
          clip-path: polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%);
        }

      `}</style>
      {/* Video de fondo FIJO ajustado a altura de pantalla */}
      <div className="fixed inset-0 z-0 overflow-hidden bg-black">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-auto h-[100vh] max-w-none opacity-70"
          style={{ height: '100vh', width: 'auto' }}
        >
          <source src="/videos/hero_video.mp4" type="video/mp4" />
          Tu navegador no soporta el elemento de video.
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black"></div>
      </div>

      {/* Contenido principal */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Título principal */}
        <div className="text-center mb-12 pt-12 md:pt-20">
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-6 font-bisteron tracking-wider relative z-10">
            <div className="block">
              <span className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">La vida es hoy.</span>
            </div>
            <div className="block mt-2">
              <span className="text-blue-400 drop-shadow-[0_0_3px_rgba(255,255,255,0.9),0_0_6px_rgba(255,255,255,0.7)] font-extrabold">Vamos a celebrar en Parapente</span>
            </div>
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 font-medium max-w-3xl mx-auto mb-8 relative z-10">
            Vuela sobre los Andes a 45 minutos de Bogotá
          </p>
        </div>

        {/* Diseño hexagonal tipo panal de abejas - Grid CSS puro */}
        <div className="relative max-w-3xl mx-auto px-4">
          {/* Contenedor principal con grid hexagonal - Desktop/Tablet */}
          <div className="relative sm:scale-[0.833] sm:origin-top max-sm:hidden" 
            style={{ 
              height: '930px',
              width: '450px',
              margin: '0 auto'
            }}
          >
            
            {/* Sistema de posicionamiento absoluto preciso - Desktop/Tablet */}
            
            {/* Fila 1 - 2 hexágonos */}
            <div style={{ position: 'absolute', top: '0', left: '45px' }}>
              <HexagonOption variant={0} />
            </div>
            <div style={{ position: 'absolute', top: '0', left: '225px' }}>
              <HexagonOption variant={1} />
            </div>
            
            {/* Fila 2 - 1 hexágono (centrado - PANAL) */}
            <div style={{ position: 'absolute', top: '155px', left: '135px' }}>
              <HexagonOption variant={2} />
            </div>
            
            {/* Fila 3 - 2 hexágonos (alineados con fila 1) */}
            <div style={{ position: 'absolute', top: '310px', left: '45px' }}>
              <HexagonOption variant={3} />
            </div>
            <div style={{ position: 'absolute', top: '310px', left: '225px' }}>
              <HexagonOption variant={4} />
            </div>
            
            {/* Fila 4 - 3 hexágonos (centrados - PANAL) */}
            <div style={{ position: 'absolute', top: '465px', left: '-45px' }}>
              <HexagonOption variant={5} />
            </div>
            <div style={{ position: 'absolute', top: '465px', left: '135px' }}>
              <HexagonOption variant={6} />
            </div>
            <div style={{ position: 'absolute', top: '465px', left: '315px' }}>
              <HexagonOption variant={8} /> {/* Cómo llegar */}
            </div>
            
            {/* Fila 5 - 2 hexágonos (alineados con fila 3) */}
            <div style={{ position: 'absolute', top: '620px', left: '45px' }}>
              <HexagonOption variant={7} /> {/* Paquetes combinados */}
            </div>
            <div style={{ position: 'absolute', top: '620px', left: '225px' }}>
              <HexagonOption variant={9} /> {/* Preguntas frecuentes */}
            </div>
            
            {/* Fila 6 - 2 hexágonos (alineados con fila 4 - PANAL COMPLETO) */}
            <div style={{ position: 'absolute', top: '775px', left: '-45px' }}>
              <HexagonOption variant={10} />
            </div>
            <div style={{ position: 'absolute', top: '775px', left: '135px' }}>
              <HexagonOption variant={11} />
            </div>
            
            {/* Hexágonos decorativos - Solo collage visual, sin links ni texto */}

          </div>

          {/* Contenedor para móvil con márgenes ajustados */}
          <div className="relative hidden max-sm:block" 
            style={{ 
              height: '630px',
              width: '315px',
              margin: '0 auto'
            }}
          >
            
            {/* Sistema de posicionamiento para móvil - Márgenes 1/4 del lado */}
            
            {/* Fila 1 - 2 hexágonos */}
            <div style={{ position: 'absolute', top: '0', left: '32px' }}>
              <HexagonOption variant={0} />
            </div>
            <div style={{ position: 'absolute', top: '0', left: '158px' }}>
              <HexagonOption variant={1} />
            </div>
            
            {/* Fila 2 - 1 hexágono (centrado - PANAL) */}
            <div style={{ position: 'absolute', top: '109px', left: '95px' }}>
              <HexagonOption variant={2} />
            </div>
            
            {/* Fila 3 - 2 hexágonos (alineados con fila 1) */}
            <div style={{ position: 'absolute', top: '218px', left: '32px' }}>
              <HexagonOption variant={3} />
            </div>
            <div style={{ position: 'absolute', top: '218px', left: '158px' }}>
              <HexagonOption variant={4} />
            </div>
            
            {/* Fila 4 - 3 hexágonos (centrados - PANAL) */}
            <div style={{ position: 'absolute', top: '327px', left: '-32px' }}>
              <HexagonOption variant={5} />
            </div>
            <div style={{ position: 'absolute', top: '327px', left: '95px' }}>
              <HexagonOption variant={6} />
            </div>
            <div style={{ position: 'absolute', top: '327px', left: '221px' }}>
              <HexagonOption variant={8} /> {/* Cómo llegar */}
            </div>
            
            {/* Fila 5 - 2 hexágonos (alineados con fila 3) */}
            <div style={{ position: 'absolute', top: '436px', left: '32px' }}>
              <HexagonOption variant={7} /> {/* Paquetes combinados */}
            </div>
            <div style={{ position: 'absolute', top: '436px', left: '158px' }}>
              <HexagonOption variant={9} /> {/* Preguntas frecuentes */}
            </div>
            
            {/* Fila 6 - 2 hexágonos (alineados con fila 4 - PANAL COMPLETO) */}
            <div style={{ position: 'absolute', top: '545px', left: '-32px' }}>
              <HexagonOption variant={10} />
            </div>
            <div style={{ position: 'absolute', top: '545px', left: '95px' }}>
              <HexagonOption variant={11} />
            </div>

            {/* Hexágonos decorativos - Solo collage visual, sin links ni texto */}

        </div>
        </div>

        {/* Información adicional */}
        <div className="text-center mt-12 pt-8 border-t border-white/20">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-8 py-4 border border-white/20">
            <div className="flex items-center space-x-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-white">15,000+</div>
                <div className="text-sm text-white/80">Vuelos realizados</div>
              </div>
              <div className="h-8 w-px bg-white/30"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">100%</div>
                <div className="text-sm text-white/80">Seguridad garantizada</div>
              </div>
              <div className="h-8 w-px bg-white/30"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">4.9★</div>
                <div className="text-sm text-white/80">Rating promedio</div>
              </div>
              <div className="h-8 w-px bg-white/30"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">45min</div>
                <div className="text-sm text-white/80">De Bogotá</div>
              </div>
            </div>
          </div>
          
          <p className="text-white/95 text-base font-semibold mt-6 max-w-2xl mx-auto drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            Todas las experiencias incluyen equipo certificado, instructores profesionales 
            y seguro de vuelo. ¡Tu seguridad es nuestra prioridad!
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <svg className="h-8 w-8 text-white/70" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Hero